import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿Es demasiado técnico para mis alumnos?',
    a: 'No. Tiene tres niveles de dificultad dentro de cada tomo: básico, intermedio y avanzado. Vos elegís el nivel para cada grupo. Sin jerga innecesaria, con ejemplos reales del campo.'
  }, {
    q: '¿Necesito equipos de laboratorio para las actividades?',
    a: 'No. El Bono 1 incluye alternativas con materiales de bajo costo — construir tu propio disco Secchi, sistemas de filtración con botellas recicladas, experimentos con herramientas de cocina. Diseñado para la realidad del docente técnico.'
  }, {
    q: '¿Puedo editar los materiales?',
    a: 'Sí. Todo viene en formatos editables para que lo adaptes a las normativas y contextos de tu institución, tu región y tu grupo.'
  }, {
    q: '¿Funciona para cursos cortos o solo para programas anuales?',
    a: 'El Bono 4 incluye versiones de 6 meses, 10 meses y adaptaciones para talleres intensivos. Flexible para cualquier formato institucional.'
  }, {
    q: '¿Qué pasa si ya conozco acuicultura?',
    a: 'El sistema no es un curso para aprender acuicultura — es la arquitectura didáctica completa para enseñarla. Tus conocimientos técnicos más este sistema igual a tus mejores clases.'
  }, {
    q: '¿Cuándo recibo el material?',
    a: 'En menos de 5 minutos después del pago. Acceso inmediato, sin esperas.'
  }, {
    q: '¿Para quién es el Mega Banco Acuícola Pro?',
    a: 'Para docentes con grupos avanzados, para capacitadores en empresas del sector, para coordinadores de programas técnicos que quieren llevar la formación al nivel de la consultoría profesional real.'
  }, {
    q: '¿En qué moneda pago?',
    a: 'El precio está en dólares estadounidenses (USD). El cobro se realiza automáticamente en la moneda de tu país al tipo de cambio del momento de la compra. Pagás en pesos, soles, quetzales, bolívares o tu moneda local sin conversión manual.'
  }, {
    q: '¿Sirve para mi país?',
    a: 'Sí. El material está pensado para toda Latinoamérica: trucha en zonas frías, tilapia en el trópico, camarón en la costa, cachama en ríos cálidos. Cubre las especies y sistemas de cada región productiva del continente.'
  }, {
    q: '¿Qué pasa si no me gusta o no me sirve?',
    a: 'Tenés 7 días de garantía total. Si revisás el material y sentís que no es lo que esperabas, escribinos y te devolvemos el 100% del dinero. Sin preguntas, sin formularios, sin esperas.'
  }];
  return <section className="py-8 px-4 bg-brand-cream" data-id="element-63">
      <div className="max-w-3xl mx-auto" data-id="element-64">
        <h2 className="text-2xl md:text-4xl font-display font-bold text-brand-navy text-center uppercase mb-5 leading-tight" data-id="element-65">
          Preguntas <span className="yellow-highlight" data-id="element-66">Frecuentes</span>
        </h2>
        <div className="space-y-2.5" data-id="element-67">
          {faqs.map((faq, i) => <div key={i} className={`bg-white rounded-lg border-2 ${openIndex === i ? 'border-brand-yellowDark' : 'border-brand-navy/30'} overflow-hidden transition-all`} data-id="element-68">
              <button className="w-full px-4 py-3 md:px-5 md:py-4 text-left flex justify-between items-center gap-3 focus:outline-none" onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-69">
                <span className={`font-display font-bold text-sm md:text-base uppercase leading-tight ${openIndex === i ? 'text-brand-navy' : 'text-brand-navy/80'}`} data-id="element-70">
                  {faq.q}
                </span>
                {openIndex === i ? <Minus className="w-5 h-5 text-brand-red shrink-0" strokeWidth={3} data-id="element-71" /> : <Plus className="w-5 h-5 text-brand-navy shrink-0" strokeWidth={3} data-id="element-72" />}
              </button>
              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ${openIndex === i ? 'max-h-96 pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-73">
                <p className="text-sm md:text-base text-brand-mute font-medium leading-snug border-t border-brand-line pt-2.5" data-id="element-74">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}